module.exports = __webpack_public_path__ + "static/media/tree_swing.a6e7c5ca.svg";